// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__NggAz","content":"styles_content__290j3"};